Last night I dreamed of Murano and of paperweights...
<br />
"Murano Fantasy" is a tribute to glassmakers who, since Antiquity, have been
producing murrines. Murrines are assembled into paperweights, with different
layouts. The central cane, when present, is often sophisticated, and the paperweight
might be signed by the artist.
